import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchRawMaterials } from '@/api/dropdowns';

export function rawMaterialsQueryOptions() {
  return queryOptions({
    queryKey: ['my-styles', 'materials', 'raw-materials'] as const,
    queryFn: fetchRawMaterials,
    staleTime: 5 * 60 * 1000,
  });
}

export function useRawMaterials() {
  return useQuery(rawMaterialsQueryOptions());
}
